import { format, getYear, isToday, isWithinInterval, isYesterday, subDays } from "date-fns";
import { IdentifiedPatientState } from "healthex-common/consent.dtos";
import React from "react";
import { getObservableT, i18nGetDateFnsLocale } from "./Infra/i18next";
import { AzureChip, ForestChip, SlateChip, TulipChip } from "./UI/HXDesktopChips.styles";
const t = getObservableT("patients");
export const getPatientDateString = (date) => {
    if (!date)
        return "";
    const locale = i18nGetDateFnsLocale();
    const targetDate = new Date(date);
    const now = new Date();
    if (isToday(targetDate)) {
        return t("Today");
    }
    else if (isYesterday(targetDate)) {
        return t("Yesterday");
    }
    else if (isWithinInterval(targetDate, {
        start: subDays(now, 7),
        end: now,
    })) {
        return format(targetDate, "EEEE", { locale });
    }
    else if (getYear(targetDate) === getYear(now)) {
        return format(targetDate, "LLL d", { locale });
    }
    else {
        return format(targetDate, "yyyy-MM-dd", { locale });
    }
};
export function getPatientStatusChip(consent) {
    if (consent.pending) {
        return React.createElement(TulipChip, { label: t("Action needed") });
    }
    switch (consent.state) {
        case IdentifiedPatientState.ENROLLING:
            return React.createElement(TulipChip, { label: t("Action needed") });
        case IdentifiedPatientState.ENROLLING_INTERESTED:
        case IdentifiedPatientState.ENROLLING_CONTACTED:
            return React.createElement(AzureChip, { label: t("Expressed interest") });
        case IdentifiedPatientState.ENROLLED:
            if (consent.updateRecordsNeeded) {
                return React.createElement(ForestChip, { label: t("Active · Action needed") });
            }
            if (consent.recordsRetrievalNeeded) {
                return React.createElement(TulipChip, { label: t("Action needed") });
            }
            return React.createElement(ForestChip, { label: t("Active") });
        case IdentifiedPatientState.DECLINED_ENROLLMENT:
            return React.createElement(SlateChip, { label: t("Ended · Declined") });
        case IdentifiedPatientState.REMOVED:
            return React.createElement(SlateChip, { label: t("Ended · Removed") });
        case IdentifiedPatientState.REVOKED_ENROLLMENT:
            return React.createElement(SlateChip, { label: t("Ended · Revoked") });
        default:
            return null;
    }
}
export function getPatientStatusSectionTitle(consent) {
    if (consent.pending) {
        return t("Response needed");
    }
    switch (consent.state) {
        case IdentifiedPatientState.ENROLLING:
            return t("Response needed");
        case IdentifiedPatientState.ENROLLING_INTERESTED:
            return t("Expressed interest in enrolling");
        case IdentifiedPatientState.ENROLLING_CONTACTED:
            return t("Contacted · Awaiting response");
        case IdentifiedPatientState.ENROLLED:
            if (consent.updateRecordsNeeded) {
                return t("Active · Action needed");
            }
            if (consent.recordsRetrievalNeeded) {
                return t("Action needed");
            }
            return t("Active");
        case IdentifiedPatientState.DECLINED_ENROLLMENT:
        case IdentifiedPatientState.REMOVED:
        case IdentifiedPatientState.REVOKED_ENROLLMENT:
            return t("Ended");
        default:
            return null;
    }
}
